var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/home"},React.createElement("path",{"id":"Icon Stroke","d":"M9.5 21.5H5V12.5H2.5V12L12 3L21.5 12V12.5H19V21.5H14.5V16H9.5V21.5Z","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round"})));
}

Home.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Home;

Home.default = Home;
